/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import App from "./helpers/app";
import "lazysizes";
import "lazysizes/plugins/respimg/ls.respimg";
import Cookies from "js-cookie";
import { decode_yii_cookie, is_breakpoint_up, make_url } from "./helpers/functions";
import Alpine from "alpinejs";
import intersect from "@alpinejs/intersect";
import tooltip from "@ryangjchandler/alpine-tooltip";
import Swiper from "./libs/swiper";
import { GrowthBook } from "@growthbook/growthbook";
import { analytics, arr_get, arr_set, ga4 } from "./helpers";
import OneTrustService from "./services/OneTrust/OneTrustService";
import notify from "./widgets/notify";
import * as Sentry from "@sentry/browser";

const $ = require("jquery");
const axios = require("axios").default;
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

const isSentryEnabled = process.env.SENTRY_ENABLED === "true";
if (isSentryEnabled) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,

    // Alternatively, use `process.env.npm_package_version` for a dynamic release version
    // if your build tool supports it.
    release: process.env.SENTRY_RELEASE,
    integrations: [
      // Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.1,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}

let growthbookExperiments = [];
const growthbook = new GrowthBook({
  apiHost: "https://cdn.growthbook.io",
  clientKey: process.env.GROWTHBOOK_CLIENT_KEY,
  enableDevMode: true,
  subscribeToChanges: false,
  backgroundSync: false,
  attributes: {
    id: global.clientUUID,
    url: location.pathname,
    browser: window.navigator.userAgent ?? null,
    country: window.navigator.language ?? null,
    mobile: !is_breakpoint_up("lg"),
  },
  onFeatureUsage: (featureKey, result) => {},
  trackingCallback: (experiment, result) => {
    growthbookExperiments.push({
      name: experiment.key,
      variant: result.key,
    });

    if (typeof window.fathom !== "undefined") {
      window.fathom.trackEvent(
        `Eksperyment: ${experiment.key}, Wariant: ${result.key}`,
        {
          _value: result.key,
        },
      );
    }

    let experimentCookie = [];
    growthbookExperiments.forEach((experiment) =>
      experimentCookie.push(
        experiment.name + " - wariant " + experiment.variant,
      ),
    );
  },
});

require("bootstrap");
require("fslightbox");
require("sticky-kit/dist/sticky-kit.min");
require("hammerjs");

require("./helpers/jquery");
require("./helpers/functions");

require("./libs/jquery.browser");
require("./libs/jquery.address");

require("./base");

require("./partials/bar");
require("./partials/filters");
require("./partials/offers-config");

require("./widgets/lead-aside");
require("./widgets/icons-menu");

// require("./pages/lead");
require("./pages/new-lead");
require("./pages/home");
require("./pages/offer-detail");
require("./pages/offers-list");
require("./pages/blog-article");
require("./pages/blog-shortcodes");
require("./pages/contact");
require("./pages/calculation");
require("./pages/advanced-search");

$(function () {
  App.bootstrap();
});

require("./../../vendor/yiisoft/yii2/assets/yii");
require("./../../vendor/yiisoft/yii2/assets/yii.activeForm");
require("./../../vendor/yiisoft/yii2/assets/yii.validation");

require("select2");
require("select2/src/js/select2/i18n/pl");
$.fn.select2.defaults.set("theme", "bootstrap4");
$.fn.select2.defaults.set("language", "pl");
$.fn.select2.defaults.set("width", "style");

let helpers = {
  decode_yii_cookie: decode_yii_cookie,
};

const growthbookFeatures = growthbook.loadFeatures();
growthbookFeatures
  .then((e) => {
    document.dispatchEvent(new CustomEvent("growthbook-features-loaded"));
  })
  .catch((e) => {
    document.dispatchEvent(new CustomEvent("growthbook-features-not-loaded"));
  });

OneTrustService.attachCallback();

global.helpers = helpers;
global.is_breakpoint_up = is_breakpoint_up;
global.jQuery = global.$ = $;
global.Cookies = Cookies;
global.app = App;
global.axios = axios;
global.Alpine = Alpine;
global.Swiper = Swiper;
global.growthbook = growthbook;
global.growthbookFeatures = growthbookFeatures;
global.growthbookExperiments = growthbookExperiments;
global.make_url = make_url;

window.jQuery = $;
window.arr_set = arr_set;
window.arr_get = arr_get;
window.notify = notify;
window.ga4 = ga4;
window.analytics = analytics;
window._AutofillCallbackHandler =
  window._AutofillCallbackHandler || function () {};

Alpine.data("autoWidth", () => ({
  calculateWidth() {
    var lDiv = document.createElement("div");

    document.body.appendChild(lDiv);

    lDiv.style.fontSize = is_breakpoint_up("lg") ? "16px" : "14px";
    lDiv.style.position = "absolute";
    lDiv.style.left = "-1000px";
    lDiv.style.top = "-1000px";

    lDiv.textContent = this.$el.value;

    var lResult = {
      width: lDiv.clientWidth,
      height: lDiv.clientHeight,
    };

    document.body.removeChild(lDiv);
    lDiv = null;

    this.$el.style.width = lResult.width + "px";
  },
}));
Alpine.bind("autoWidthEvents", () => ({
  "x-init"() {
    this.calculateWidth();
  },
  "x-on:change"() {
    this.$nextTick(() => this.calculateWidth());
  },
  "@blur"() {
    this.calculateWidth();
  },
  "@keyup"() {
    this.calculateWidth();
  },
}));

Alpine.plugin(intersect);
Alpine.plugin(tooltip);
Alpine.start();
